import {EmailSignUpValues} from "./SignUpWithEmailForm";
import {useState} from "react";
import {signUpWithEmailAndPassword} from "./sign-up-with-email-and-password";
import {AccountsError} from "../login/useLoginWithEmail";
import {SwitchAccountStore} from "../switch-account/switch-account-store";
import {CaptchaStore} from "../captcha/store";
import {LinkAccountStore} from "../link-account/store";

type UseSignUpWithEmailReturn = {
  isSubmitting: boolean;
  isSuccess: boolean;
  showCaptcha: boolean;
  error?: AccountsError;
  signUp: (values: EmailSignUpValues) => void;
  setCaptchaToken: (token: string) => void;
};
export const useSignUpWithEmail = (): UseSignUpWithEmailReturn => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [showCaptcha, setShowCaptcha] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [captchaToken, setCaptchaToken] = useState<string>();
  const [error, setError] = useState<AccountsError>();

  return {
    isSubmitting,
    isSuccess,
    showCaptcha,
    error,
    signUp: (values: EmailSignUpValues) => {
      if (captchaToken) {
        setIsSubmitting(true)
        signUpWithEmailAndPassword(values)
        .then(() => {
          setIsSuccess(true);
          SwitchAccountStore.clear();
        })
        .catch(err => {
          LinkAccountStore.setEmail(values.email);
          setError(err);
        })
        .finally(() => setIsSubmitting(false));
      } else {
        setShowCaptcha(true)
      }
    },
    setCaptchaToken: (token) => {
      console.info("setting captcha token", token);
      setCaptchaToken(token);
      CaptchaStore.set(token);
    },
  }
};
